import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import styles from './ContextualActions.styles.scss';
const template = html `<slot></slot>`;
let ContextualActionsComponent = class ContextualActionsComponent extends ChameleonElementMixin(FASTElement) {
};
__decorate([
    attr
], ContextualActionsComponent.prototype, "variant", void 0);
ContextualActionsComponent = __decorate([
    customElement({
        name: 'chameleon-contextual-actions',
        template,
        styles,
    })
], ContextualActionsComponent);
export { ContextualActionsComponent };
